(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eh-media-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('eh-video-gallery')) return;

    class EHVideoGallery extends HTMLElement {
      connectedCallback() {
        if (this._active) return;
        this._active = true;
        this._startFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected) return;
        this._words = Array.from(this.querySelectorAll('[data-eh-vg-word]'));
        this._videos = Array.from(this.querySelectorAll('.eh-vg__video'));
        this._button = this.querySelector('[data-eh-vg-toggle]');
        this._buttonText = this.querySelector('[data-eh-vg-toggle-text]');
        this._visible = new Set();
        this._pending = new Set();
        this._failed = new Set();
        this._manualPlayback = null;
        this._autoplayDenied = false;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._events = [];
        this._scheduleFit = () => {
          cancelAnimationFrame(this._fitFrame);
          this._fitFrame = requestAnimationFrame(() => this.fitWords());
        };
        this._onVisibility = () => this.syncPlayback();
        this._onMotion = () => this.syncPlayback();
        this._onToggle = () => {
          const playing = this._videos.some(video => !video.paused && !video.ended);
          this._manualPlayback = !(playing || this._pending.size > 0);
          this._autoplayDenied = false;
          this.syncPlayback();
        };

        this._videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          const frameReady = () => video.setAttribute('data-eh-vg-frame', '');
          const update = () => this.updateButton();
          const failed = () => {
            this._failed.add(video);
            this._pending.delete(video);
            video.removeAttribute('data-eh-vg-frame');
            this.updateButton();
          };
          [['loadeddata', frameReady], ['playing', frameReady], ['play', update], ['pause', update], ['error', failed]].forEach(([type, handler]) => {
            video.addEventListener(type, handler);
            this._events.push([video, type, handler]);
          });
          if (video.readyState >= 2) frameReady();
        });

        if (this._button) {
          this._button.hidden = this._videos.length === 0;
          this._button.addEventListener('click', this._onToggle);
        }
        document.addEventListener('visibilitychange', this._onVisibility);
        if (this._motion.addEventListener) this._motion.addEventListener('change', this._onMotion);
        else this._motion.addListener(this._onMotion);

        if ('ResizeObserver' in window) {
          this._resize = new ResizeObserver(this._scheduleFit);
          this._words.forEach(word => this._resize.observe(word));
        } else {
          window.addEventListener('resize', this._scheduleFit);
        }
        this.fitWords();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this._active && this.isConnected) this._scheduleFit();
          });
        }

        if ('IntersectionObserver' in window) {
          this._intersection = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) this._visible.add(entry.target);
              else this._visible.delete(entry.target);
            });
            this.syncPlayback();
          }, { threshold: 0.1 });
          this._words.forEach(word => this._intersection.observe(word));
        } else {
          this._words.forEach(word => this._visible.add(word));
          this.syncPlayback();
        }
        this.updateButton();
      }

      fitWords() {
        if (!this._active) return;
        this._words.forEach(word => {
          const text = word.querySelector('[data-eh-vg-mask-text]');
          const group = word.querySelector('[data-eh-vg-text-group]');
          if (!text || !group) return;
          const width = word.clientWidth;
          const height = word.clientHeight;
          if (!width || !height) return;
          try {
            let box = text.getBBox();
            // Measure visible ink, rather than the font's extra ascender/descender space.
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (context) {
              const font = getComputedStyle(text);
              context.font = `${font.fontStyle} ${font.fontWeight} ${font.fontSize} ${font.fontFamily}`;
              const ink = context.measureText(text.textContent);
              const inkWidth = ink.actualBoundingBoxLeft + ink.actualBoundingBoxRight;
              const inkHeight = ink.actualBoundingBoxAscent + ink.actualBoundingBoxDescent;
              if (Number.isFinite(inkWidth) && inkWidth > 0 && inkHeight > 0) {
                box = { x: -ink.actualBoundingBoxLeft, y: -ink.actualBoundingBoxAscent, width: inkWidth, height: inkHeight };
              }
            }
            if (!box.width || !box.height) return;
            const fill = Math.max(0.4, Math.min(1, Number(word.dataset.fill || 94) / 100));
            const scale = Math.min((width * fill) / box.width, (height * fill) / box.height);
            const x = (width - box.width * scale) / 2 - box.x * scale;
            const y = (height - box.height * scale) / 2 - box.y * scale;
            group.setAttribute('transform', `translate(${x} ${y}) scale(${scale})`);
            word.setAttribute('data-eh-vg-fitted', '');
          } catch (error) {
            // Keep readable ordinary text if SVG measurement is unavailable.
            word.removeAttribute('data-eh-vg-fitted');
          }
        });
        this.syncPlayback();
      }

      wantsPlayback() {
        if (this._manualPlayback !== null) return this._manualPlayback;
        const saveData = navigator.connection && navigator.connection.saveData;
        return this.dataset.autoplay === 'true' && !this._motion.matches && !saveData && !this._autoplayDenied;
      }

      syncPlayback() {
        if (!this._active || !this._videos) return;
        const wantsPlay = this.wantsPlayback() && !document.hidden;
        this._videos.forEach(video => {
          const word = video.closest('[data-eh-vg-word]');
          const canPlay = wantsPlay && this._visible.has(word) && word.hasAttribute('data-eh-vg-fitted') && !this._failed.has(video);
          if (!canPlay) {
            video.pause();
            return;
          }
          if (!video.paused || this._pending.has(video)) return;
          this._pending.add(video);
          const attempt = video.play();
          if (attempt && typeof attempt.then === 'function') {
            attempt.then(() => {
              this._pending.delete(video);
              if (!this._active || document.hidden || !this.wantsPlayback() || !this._visible.has(word)) video.pause();
              this.updateButton();
            }).catch(error => {
              this._pending.delete(video);
              if (error.name === 'NotAllowedError') this._autoplayDenied = true;
              if (error.name === 'NotSupportedError') this._failed.add(video);
              this.updateButton();
            });
          } else {
            this._pending.delete(video);
          }
        });
        this.updateButton();
      }

      updateButton() {
        if (!this._active || !this._buttonText) return;
        const playing = this._videos.some(video => !video.paused && !video.ended);
        this._buttonText.textContent = playing || this._pending.size > 0 ? 'Pause video' : 'Play video';
        this._button.disabled = this._videos.length > 0 && this._failed.size === this._videos.length;
        if (this._button.disabled) this._buttonText.textContent = 'Video unavailable';
      }

      disconnectedCallback() {
        this._active = false;
        cancelAnimationFrame(this._startFrame);
        cancelAnimationFrame(this._fitFrame);
        if (this._resize) this._resize.disconnect();
        if (this._intersection) this._intersection.disconnect();
        if (this._scheduleFit) window.removeEventListener('resize', this._scheduleFit);
        if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
        if (this._button) this._button.removeEventListener('click', this._onToggle);
        if (this._motion && this._onMotion) {
          if (this._motion.removeEventListener) this._motion.removeEventListener('change', this._onMotion);
          else this._motion.removeListener(this._onMotion);
        }
        (this._events || []).forEach(([element, type, handler]) => element.removeEventListener(type, handler));
        (this._videos || []).forEach(video => video.pause());
      }
    }
    customElements.define('eh-video-gallery', EHVideoGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
